export default __webpack_public_path__ + "static/thumb-5-cde298a64a5097c28bd64cd2ffaa46fe.jpg";